import { createSlice } from "@reduxjs/toolkit";
import { clearToken } from "../auth/authHelpers";

const initialState = {
    status: "idle",   // "idle" | "loading" | "succeeded" | "failed"
    error: null,
    user: null,
    message: "",
};

const appointmentSlice = createSlice({
    name: "appointment",
    initialState,
    reducers: {
        logout: (state) => {
            state.status = "idle";
            state.error = null;
            state.user = null;
            state.message = "";
            clearToken();
        },
    },
    // extraReducers: (builder) => {
    //     builder

    // },
});

// export const { } = appointmentSlice.actions;
export default appointmentSlice.reducer;
